export const INVALID_KEY = '00000000-0000-0000-0000-000000000000';
export const SSO_LOGIN_KEY = 'cqm-sso-login';
export const getErrorMessage = (action, userId, practiceGuid) => `Error while ${action} for userId=[${userId}] and practiceGuid=[${practiceGuid}]`;

export const PROVIDER_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
};